import React, { useMemo } from "react";
import useAxios from "axios-hooks";
import DataTable from "../Base/DataTable";
import { useParams } from "react-router";

export default function Locales() {
    let { id } = useParams();
  const [{ data, loading, error }, executeDelete] = useAxios({}, { manual: true });

  const headerActions = useMemo(
    () => [
      {
        type: "add",
      },
    ],
    []
  );

  const columns = useMemo(
    () => [
      { accessor: "locale", Header: "locale" }
    ],
    [executeDelete]
  );
  return <DataTable url={`localization/locale`} headerActions={headerActions} title="Localies" columns={columns}></DataTable>;
}
